<template>
	<div class="featured_post_listing">
		<div class="container">

			<div class='inner'>
				<post-tile
					v-for="(tile, index) in parsedPageLinks"
					:key="index"
					:name="tile.title"
					:short_description="tile.description"
					:image="tile.image ? tile.image.url : null"
					:permalink="{
                url: tile.url,
                target: '_self',
                title: tile.title,
              }"
					:tag="tile.tag ? tile.tag : null"
					:post_type="tile.post_type"
					:date="tile.date"
					:index="'index_' + index"
					data-aos="fade-up"
					data-aos-duration="300"
					:data-aos-offset="50"
					:data-aos-delay="index * 50"
				></post-tile>
			</div>

		</div>
	</div>
</template>

<script>
import PostTile from './PostTile.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
		};
	},

	props: {
		basic_page_links_description: {},
		type: {},
		section_id: {},
		no_slider: {
			default: 'false',
		},
	},

	computed: {
		parsedPageLinks() {
			if (this.basic_page_links_description) {
				return JSON.parse(this.basic_page_links_description);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.cta) {
				return JSON.parse(this.cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		PostTile,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_post_listing {
	grid-column: span 12;

	overflow: hidden;
	border-top: 1px solid var(--light-grey);
	background: white;

	.slider-slider {
		grid-column: span 12;
		/* overflow: hidden; */
		padding-top: 55px;
		margin-top: -55px;
		position: relative;
		z-index: 5;

		@media (max-width: $tablet) {
			grid-column: span 12;
			overflow: visible;
			padding-top: 24px;
			margin-top: unset;
		}

		@media (max-width: $mobile-xl) {
			grid-column: span 12;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
		}

		.swiper-slider {
			pointer-events: none;
		}

		.swiper-slide {
			height: unset;

			&:not(.swiper-slide-visible) {
				opacity: 0.3;
			}
		}
	}

	.swiper-wrapper {
		z-index: 15;
	}

	header {
		grid-column: span 12;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		// border-top: 1px solid var(--white);
		// padding-top: var(--gutter-tablet-desktop);

		@media (max-width: $tablet) {
			grid-column: span 12;
			justify-content: space-between;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
			flex-direction: column;
			align-items: center;
			gap: 10px;
		}

		h2 {
			/* font: normal normal 500 2px/24px var(--primary-font-family); */
			color: var(--black);
			margin: 0;

			@media (max-width: $tablet) {
				color: var(--black);
			}
		}

		h5 {
			margin: 0;
		}

		&.header-mobile {
			display: none;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				border-top: 0 solid var(--black);
				padding-top: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 40px;
			}

			/* a {
				&.site_button_secondary {
					padding-left: 0;
					display: none;
					width: auto;

					@media (max-width: $mobile-xl) {
						display: flex;
						color: var(--white);
					}
				}
			} */
		}

		&.header-desktop {
			position: relative;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				pointer-events: none;

				a {
					&.site_button_secondary {
						display: none;
					}
				}
			}
		}
	}

	.container {
		column-gap: var(--gutter-tablet-desktop);
		row-gap: calc(var(--gutter-tablet-desktop) * 1);

		@media (max-width: $tablet) {
			grid-template-columns: repeat(12, 1fr);
			column-gap: var(--gutter-mobile);
			row-gap: var(--gutter-mobile);
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			column-gap: var(--gutter-mobile);
		}

		.inner {
			grid-column: span 9;
			max-width: var(--max-width);
			margin: 0 auto;
			padding: 0 40px;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			gap: 50px;
			height: max-content;
			border-left: 1px solid var(--light-grey);
			border-right: 1px solid var(--light-grey);
			padding: 50px 50px 50px;

			@media (max-width: 1920px) {
				gap: var(--gutter-tablet-desktop);
			}

			@media (max-width: $mobile-xl) {
				grid-template-columns: repeat(4, 1fr);
				padding: 0 var(--gutter-mobile);
				border-left: unset;
				border-right: unset;
				padding: var(--gutter-mobile) 0;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			}
		}

		.post_tile {
			/* height: auto;
			transition: 0.2s ease opacity; */

			&:first-of-type {
				grid-column: span 12;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			grid-column: span 6;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			/* @media (max-width: 1920px) {
				grid-column: span 3;
			}

			@media (max-width: 1490px) {
				grid-column: span 3;
			}

			@media (max-width: $tablet) {
				grid-column: span 3;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			} */

			&::v-deep {
				.lower {
					/* justify-content: flex-start; */

					.site_button_secondary {
						text-decoration: none;
					}
				}

				.content {
					background: var(--white);
				}

				@media (max-width: $mobile-xl) {
					display: flex;
					flex-direction: column;

					.content {
						height: auto;
						background: var(--white);
					}
				}
			}

			&.swiper-slide-next {
				@media (max-width: $mobile-xl) {
					opacity: 0.3 !important;
				}
			}

			&.swiper-slide-prev {
				@media (max-width: $mobile-xl) {
					opacity: 0.3 !important;
				}
			}
		}
	}
}

.swiper {
	width: 100%;
	/* height: 100%; */
	position: relative;
}

.swiper-next-prev {
	position: absolute;
	width: 100%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 40;
	z-index: 20;

	/* @media (max-width: $mobile-xl) {
		max-width: calc(100% - 40px);
		top: -42px;
		bottom: unset;
		margin: 0 20px;
	} */

	.prev {
		opacity: 1;

		@media (max-width: $tablet) {
			top: 50%;
		}
	}

	.next {
		opacity: 1;

		@media (max-width: $tablet) {
			top: 50%;
		}
	}
}

.swiper-pagination {
	/* position: relative !important; */
	grid-column: span 12;
	display: inline-flex;
	justify-content: center;
	gap: 10px;
	left: 0;
	width: 100%;
	position: absolute !important;
	/* top: -72px !important; */
	bottom: unset !important;
	flex-wrap: wrap;
	z-index: 10;
	margin-top: var(--spacer);

	@media (max-width: $mobile-xl) {
		gap: 8px;
		top: unset !important;
		bottom: -40px !important;
	}

	& > .swiper-pagination-bullet-active {
		background: var(--black) !important;
	}
}

/* .swiper-slide-prev {
	transition: 0.2s ease opacity;
	opacity: 0.2 !important;
} */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedPostListing.vue